import Validator from './Validator';

export default function validateCreateUser(form) {
  return Validator.create(form, {
    firstname: {
      validators: {
        notEmpty: {
          message: 'Vorname ist ein Pflichtfeld',
        },
      },
    },
    lastname: {
      validators: {
        notEmpty: {
          message: 'Nachname ist ein Pflichtfeld',
        },
      },
    },
    username: {
      validators: {
        notEmpty: {
          message: 'Benutzername ist ein Pflichtfeld',
        },
      },
    },
    password: {
      validators: {
        notEmpty: {
          message: 'Passwort ist ein Pflichtfeld',
        },
        stringLength: {
          message: 'Passwort muss mindestens 6 Zeichen enthalten',
          min: 6,
        },
      },
    },
    email: {
      validators: {
        notEmpty: {
          message: 'E-Mail-Adresse ist ein Pflichtfeld',
        },
        emailAddress: {
          message: 'Die eingegebene E-Mail-Adresse ist nicht korrekt',
        },
      },
    },
    companyId: {
      validators: {
        notEmpty: {
          message: 'Unternehmen ist ein Pflichtfeld',
        },
      },
    },
  });
}
